import { useTexts } from 'utils/useTexts';
import Footer from '@components/shared/Footer/Footer';
import EnterLicensePlateForm from '@components/EnterLicensePlateForm/EnterLicensePlateForm';

const EnterLicensePlate = () => {
  const { t } = useTexts();

  return (
    <>
      <EnterLicensePlateForm />

      <Footer text={t('enterLicensePlate.footer.footerText')} />
    </>
  );
};

export default EnterLicensePlate;
